import { SharingDraft } from '@/types';
import { getImgBaseUrl } from '@/utils/imageUrls/getImgBaseUrl';
import { stringifyImageParams } from './stringifyImageParams';

export const getDraftImageUrl = (draft: SharingDraft, size: number) =>
  `${getImgBaseUrl()}/products/${draft.vp}${stringifyImageParams(
    { width: size, height: size, viewId: draft.viewId },
    '&'
  )}.png`;
